import { Loader } from '@googlemaps/js-api-loader';

export default defineNuxtPlugin(async ({$config}) => {
  if (window && !(window as any).google) {
    const loader = new Loader({
      apiKey: $config.public.googleApiKey,
      version: 'weekly',
      libraries: ['places', 'geometry'],
    });

    await loader.load();
  }
});

